import React, {Fragment} from 'react';

function Select(props) {
    const {
        labelText,
        name,
        options,
        selectedOption,
        onChange,
        error,
        errorText
    } = props;

    const optionsList = options.map(option => {
        return (
            <option
                key={option.Id}
                value={option.Id}>
                {option.Name}
            </option>
        )
    });

    return (
        <Fragment>
            <strong><label htmlFor={name}>{labelText}</label></strong>
            <select
                name={name}
                id={name}
                value={selectedOption}
                onChange={(event) => onChange(event.target.value)}
                disabled={error}
            >
                {optionsList}
            </select>
            {error && <p className="sds-widget__error-message">{errorText}</p>}
        </Fragment>
    )
}

export default Select;